import {
	getConfigFieldsCrud,
	getConfigVoucher,
	getTableGlobalProductAttr,
	productAttrGlobalApply,
	productAttrGlobalAssign,
	productAttrGlobalAssignConfirm,
	productAttrGlobalAssignEdit,
	productAttrGlobalAssignPaginate,
	productAttrIndividualApply,
	productCleanButton,
	selectSearchedProducts,
	voucherCancel
} from 'actions'
import CommonModal from 'components/common/commonModal'
import SearchProductsForm from 'components/SearchProducts/SearchProductsForm'
import SearchProductsTable from 'components/SearchProducts/SearchProductsTable'
import {
	P_PRODUCTS_ATTRIBUTES_GLOBAL_UPLOAD,
	P_SEARCH_PRODUCTS
} from 'constants/ConfigProcessNames'
import { getFiltersData } from 'lib/Utils'
import { ICrudFieldStructure } from 'models/CrudInterface'
import {
	ICrudApplyProductAttrFilters,
	ICrudApplyProductAttrIndividual,
	ICrudProductAttrGlobalAssignConfirm,
	IProductAttributesGlobalUploadProps,
	IProductAttributesGlobalUploadState
} from 'models/ProductGlobalUploadInterface'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import _ from 'underscore'
import { LANDING } from 'utils/RoutePath'
import ProductAttributesGlobalUploadForm from './ProductAttributesGlobalUploadForm'
import ProductAttributesGlobalUploadTable from './ProductAttributesGlobalUploadTable'

class ProductAttributesGlobalUpload extends Component<
	IProductAttributesGlobalUploadProps,
	IProductAttributesGlobalUploadState
> {
	constructor(props: IProductAttributesGlobalUploadProps) {
		super(props)
		this.state = {
			paramsSearch: {
				idOperacion: props.idOperacion || 0,
				page_size: 10,
				page_number: 1,
				orden: 1
			},
			attributesList: {
				lista: []
			},
			gridAttrList: {
				lista: []
			},
			showEditPopup: false,
			disableForm: false,
			showSearchModal: false
		}
	}

	componentDidMount(): void {
		this.props.getConfigFieldsCrud({ cod_abm: P_SEARCH_PRODUCTS })
	}

	componentDidUpdate = (prevProps: IProductAttributesGlobalUploadProps) => {
		const {
			productAttrList,
			getTableGlobalProductAttr,
			idOperacion,
			globalProductAttr,
			productAttrPagination,
			productAttrIndividualAccept,
			productAttrGlobalAssignPaginate,
			voucherTypeCancel,
			authUser
		} = this.props
		const {
			productAttrList: prevProductAttrList,
			globalProductAttr: prevGlobalAttr,
			productAttrIndividualAccept: prevProductAttrIndividualAccept,
			productAttrPagination: prevProductAttrPagination,
			voucherTypeCancel: prevVoucherTypeCancel
		} = prevProps

		const { paramsSearch } = this.state

		if (prevProductAttrList !== productAttrList && productAttrList) {
			getTableGlobalProductAttr(idOperacion || 0)
		}

		if (prevGlobalAttr !== globalProductAttr && globalProductAttr) {
			this.handleAttribsValues(globalProductAttr)
		}

		if (
			prevProductAttrIndividualAccept !== productAttrIndividualAccept &&
			productAttrIndividualAccept
		) {
			productAttrGlobalAssignPaginate(paramsSearch)
		}
		if (prevProductAttrList !== productAttrList && productAttrList) {
			this.setState({
				gridAttrList: { ...productAttrList }
			})
			this.setState({ disableForm: true })
		}
		if (
			prevProductAttrPagination !== productAttrPagination &&
			productAttrPagination
		) {
			this.setState({
				gridAttrList: { ...productAttrPagination }
			})
		}
		if (prevVoucherTypeCancel !== voucherTypeCancel && voucherTypeCancel) {
			this.props.history.push(`${LANDING}/${authUser.userCompany}`)
		}
	}

	handleFormApply = (values: ICrudApplyProductAttrFilters) => {
		const { productAttrGlobalApply, idOperacion } = this.props

		const newFilters = {
			...values,
			idOperacion: idOperacion || 0,
			page_size: 10,
			page_number: 1
		}
		productAttrGlobalApply(newFilters)
		this.setState({
			paramsSearch: newFilters
		})
	}

	handleModalSubmit = (values: ICrudApplyProductAttrIndividual) => {
		const { idOperacion } = this.props

		this.props.productAttrIndividualApply({
			...values,
			idOperacion: idOperacion || 0
		})

		this.setState({ showEditPopup: false })
	}

	handleOpen = (cell: any, row: any) => {
		const { productAttrGlobalAssignEdit, idOperacion } = this.props

		productAttrGlobalAssignEdit({
			niprod: row.niprod,
			idOperacion: idOperacion || 0
		})

		this.setState((prevState) => ({
			showEditPopup: !prevState.showEditPopup
		}))
	}

	handleCloseEditPopup = () => {
		this.setState({ showEditPopup: false })
	}

	handleButtonSubmit = () => {
		const { page_size, page_number, orden } = this.state.paramsSearch
		const { idOperacion } = this.props

		const confirmGlobalAssign: ICrudProductAttrGlobalAssignConfirm = {
			page_size: page_size,
			page_number: page_number,
			orden: orden,
			idOperacion: idOperacion || 0
		}

		this.props.productAttrGlobalAssignConfirm(confirmGlobalAssign)
	}

	handleButtonClean = () => {
		this.setState({
			gridAttrList: {
				page_size: 10,
				page_number: 1,
				total_count: 0,
				lista: []
			},
			disableForm: false,
			paramsSearch: {
				idOperacion: this.props.idOperacion || 0,
				page_size: 10,
				page_number: 1,
				orden: 1
			}
		})
		this.props.productCleanButton()
	}

	handleGlobalAssign = (values: any) => {
		const { page_size, page_number, orden } = this.state.paramsSearch
		const { idOperacion } = this.props

		const globalAssignValues = {
			idOperacion: idOperacion ?? 0,
			page_size: page_size,
			page_number: page_number,
			orden: orden,
			codigo: values.Atrib_asig,
			valor: values.atrib_valor || values.descrip_valor
		}

		this.props.productAttrGlobalAssign(globalAssignValues)
	}

	handleChangeTable = (type: String, pagination: any) => {
		const { paramsSearch } = this.state
		const { productAttrGlobalAssignPaginate, idOperacion } = this.props
		if (type === 'pagination') {
			productAttrGlobalAssignPaginate({
				...paramsSearch,
				idOperacion: idOperacion || 0,
				page_size: pagination.sizePerPage,
				page_number: pagination.page,
				orden: paramsSearch.orden
			})
		}
	}

	handleAttribsValues = (attribs: any) => {
		this.setState({
			attributesList: {
				lista: attribs.lista
			}
		})
	}

	// to close search products modal
	handleCloseSearchModal = () => {
		this.setState({ showSearchModal: false })
	}

	// to open and close search modal
	handleToggleSearchModal = () => {
		this.setState((state) => ({
			showSearchModal: !state.showSearchModal
		}))
	}

	handleSendSearch = (values: any) => {
		const { idOperacion, selectSearchedProducts } = this.props
		this.setState({ showSearchModal: false })
		selectSearchedProducts({ ...values, idOperacion })
	}

	renderSearchProducts = () => {
		const { fieldsConfig } = this.props
		return (
			<>
				<SearchProductsForm
					fields={getFiltersData(fieldsConfig.campos, {
						agrupador: 'formulario'
					})}
					isSearchProducts={true}
					handleSendSearch={this.handleSendSearch}
				/>
				<SearchProductsTable
					fields={getFiltersData(fieldsConfig.campos, {
						agrupador: 'grilla'
					})}
				/>
			</>
		)
	}

	render() {
		const { t, config, productAttrList, idOperacion, selectedProducts } =
			this.props
		const {
			attributesList,
			disableForm,
			showEditPopup,
			gridAttrList,
			showSearchModal
		} = this.state

		const tableFields = config
			? getFiltersData(config.campos, { agrupador: 'grilla' })
			: []
		const modalFields = config
			? getFiltersData(config.campos, { agrupador: 'grupo.modal' })
			: []
		const attributesFields = []

		if (productAttrList?.lista?.length > 0) {
			for (let it = 0; it < 5; it++) {
				const newField: ICrudFieldStructure = {
					idCampo: '',
					label: 'Atributo',
					descrip: 'Atributo',
					mascara: '',
					editable: false,
					visible: 1,
					requerido: false,
					valid: '',
					agrupador: 'atributo'
				}
				let fieldExists = false
				_.each(productAttrList.lista, (item) => {
					if (
						item.listaAtribs[it] &&
						item.listaAtribs[it].cod_atrib !== '' &&
						!fieldExists
					) {
						newField.idCampo = item.listaAtribs[it].cod_atrib
						newField.label = item.listaAtribs[it].desc_atrib
						newField.descrip = item.listaAtribs[it].cod_atrib

						fieldExists = true
					}
				})

				if (fieldExists) attributesFields.push(newField)
			}
		}

		const formProps = {
			fields: config.campos,
			t: t,
			handleButtonSubmit: this.handleButtonSubmit,
			handleSubmit: this.handleFormApply,
			handleGlobalAssign: this.handleGlobalAssign,
			attributesList: attributesList,
			disableForm: disableForm,
			idOperacion: idOperacion,
			handleOpenModal: this.handleToggleSearchModal,
			selectedProducts: selectedProducts,
			handleButtonClean: this.handleButtonClean
		}

		const tableProps = {
			idOperacion: idOperacion || 0,
			tableFields: [...tableFields, ...attributesFields],
			modalFields: [...modalFields, ...attributesFields],
			t: t,
			disableForm: disableForm,
			handleModalSubmit: this.handleModalSubmit,
			handleChangeTable: this.handleChangeTable,
			fields: gridAttrList,
			handleCloseEditPopup: this.handleCloseEditPopup,
			showEditPopup: showEditPopup,
			handleOpen: this.handleOpen
		}

		const propsSearchModal = {
			showModal: showSearchModal,
			handleCloseModal: this.handleToggleSearchModal,
			modalTitle: 'Busqueda de productos',
			modalBody: showSearchModal ? this.renderSearchProducts() : <></>,
			buttons: false,
			sizeModal: 'xl'
		}

		return (
			<>
				<ProductAttributesGlobalUploadForm {...formProps} />
				<ProductAttributesGlobalUploadTable {...tableProps} />
				{showSearchModal && <CommonModal {...propsSearchModal} />}
			</>
		)
	}
}
const mapStateToProps = ({
	voucher,
	auth,
	configCrud,
	productAttrGlobalUpload,
	tableCalls,
	searchProducts
}: any) => {
	const config = voucher.config
		? voucher.config[P_PRODUCTS_ATTRIBUTES_GLOBAL_UPLOAD]
		: null

	const { fieldsConfig } = configCrud
	const { authUser } = auth
	const { globalProductAttr, voucherTypeCancel } = tableCalls
	const { selectedProducts } = searchProducts
	const {
		productAttrList,
		productAttrIndividualAccept,
		productAttrGlobalAssignConfirmed,
		productAttrGlobalAssigned,
		productAttrEdit,
		productAttrPagination
	} = productAttrGlobalUpload
	return {
		config,
		authUser,
		fieldsConfig,
		productAttrList,
		productAttrIndividualAccept,
		productAttrGlobalAssignConfirmed,
		productAttrGlobalAssigned,
		globalProductAttr,
		productAttrEdit,
		productAttrPagination,
		voucherTypeCancel,
		selectedProducts
	}
}

const connectForm = connect(mapStateToProps, {
	getConfigVoucher,
	getConfigFieldsCrud,
	productAttrGlobalAssign,
	productAttrGlobalApply,
	productAttrIndividualApply,
	productAttrGlobalAssignConfirm,
	getTableGlobalProductAttr,
	productAttrGlobalAssignEdit,
	productAttrGlobalAssignPaginate,
	productCleanButton,
	voucherCancel,
	selectSearchedProducts
})(ProductAttributesGlobalUpload)
export default withTranslation()(withRouter(connectForm))
